import {MmSyncableModel} from '@docma-mm-core/model/mm-syncable.model';
import {ScribbleLayerData} from '@docma-mm-core/scribble/scribble-layers';
import {User} from '@docma-mm-core/user/user';

export class ScribbleData {

  constructor(init?: Partial<ScribbleData>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  Id?: number;
  UniqueId?: string;
  Creator?: User;
  Modifier?: User;
  CreatedOn?: Date;
  ModifiedOn?: Date;

  ScribbleLayer?: ScribbleLayerData;

  PinShape?: number;
  PinStyle?: number;

  RelativeBasePointToParentPositionX?: number;
  RelativeBasePointToParentPositionY?: number;

  RelativeAnchorToCanvasPositionX?: number;
  RelativeAnchorToCanvasPositionY?: number;
  RelativeAnchorToParentPositionX?: number;
  RelativeAnchorToParentPositionY?: number;

  AbsoluteTextBoxToCanvasOffsetX?: number;
  AbsoluteTextBoxToCanvasOffsetY?: number;
  RelativeTextBoxToCanvasOffsetX?: number;
  RelativeTextBoxToCanvasOffsetY?: number;

  RelativeScaleX?: number;
  RelativeScaleY?: number;

  IsRotatable?: boolean;
  BackgroundColorValue?: string;
  FillColorValue?: string;
  BorderColorValue?: string;
  BorderWidth?: number;
  TextBoxFontSize?: number;
  TextBoxFontColorValue?: string;
  TextBoxBackgroundColorValue?: string;
  TextBoxBorderColorValue?: string;
  TextBoxBorderWidth?: number;
  TextBoxAlignmentValue?: number;

  ScribblePath?: string;
  Text?: string;
}

export class Scribble extends MmSyncableModel<ScribbleData> {
  constructor(init?: any) {
    super(init);
    if (init) {
      Object.assign(this, init);
    }
  }
}
